import { Button, Snackbar, SnackbarCloseReason } from '@material-ui/core';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import LocalizationContext from '../../contexts/LocalizationContext';

interface NewVersionPopupState {
    open: boolean;
    worker: ServiceWorker | null;
}

const NewVersionPopup = () => {
    const localization = useContext(LocalizationContext);
    const [state, setState] = useState<NewVersionPopupState>({
        open: false,
        worker: null,
    });

    const addEventHandlers = useCallback(
        (reg: ServiceWorkerRegistration) => {
            setState((s: NewVersionPopupState) => ({ ...s, worker: reg.active }));

            let newWorker: ServiceWorker | null;
            reg.addEventListener('updatefound', () => {
                newWorker = reg.installing;
                setState((s: NewVersionPopupState) => ({ ...s, worker: newWorker }));

                if (!newWorker) return;
                newWorker.addEventListener('statechange', () => {
                    switch (newWorker?.state) {
                        case 'installed':
                            if (navigator.serviceWorker.controller) {
                                setState((s: NewVersionPopupState) => ({ ...s, open: true }));
                            }
                            break;
                    }
                });
            });
        },
        [setState]
    );

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistration('/service-worker.js').then((reg: ServiceWorkerRegistration | undefined) => {
                if (reg) addEventHandlers(reg);
                else
                    navigator.serviceWorker.register('/service-worker.js', { type: 'module' }).then((reg: ServiceWorkerRegistration) => addEventHandlers(reg));
            });
        }
    }, [addEventHandlers]);

    return ReactDOM.createPortal(
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={state.open}
            onClose={(_: any, reason: SnackbarCloseReason) => setState({ ...state, open: reason === 'clickaway' ? state.open : false })}
            message={localization.strings.newVersionAvailable}
            action={
                <Button
                    color='secondary'
                    size='small'
                    onClick={() => {
                        if (!state?.worker){}
                        else {
                            state.worker.postMessage({ type: 'SKIP_WAITING' });
                            setState({ ...state, open: false });
                        }
                    }}>
                    {localization.strings.refresh}
                </Button>
            }
        />,
        document.getElementById('refresh-banner') || document.body
    );
};

export default NewVersionPopup;
